import { render, staticRenderFns } from "./CrudView.vue?vue&type=template&id=1b860d4e&"
import script from "./CrudView.vue?vue&type=script&lang=js&"
export * from "./CrudView.vue?vue&type=script&lang=js&"
import style0 from "./CrudView.vue?vue&type=style&index=0&id=1b860d4e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports